/* eslint-disable
    @typescript-eslint/no-explicit-any,
    react/prefer-stateless-function
*/
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import Tooltip, {TooltipPlacement} from 'ui-library/bs/Tooltip';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface Props {
  compact: boolean;
  onClick: (...args: Array<any>) => any;
}

class SearchButton extends React.Component<Props> {
  static defaultProps = {
    compact: true,
  };

  override render(): JSX.Element {
    if (this.props.compact) {
      return (
        <Tooltip title="Search" placement={TooltipPlacement.BOTTOM}>
          <Button
            aria-label="Search"
            buttonStyle={ButtonStyle.TERTIARY_WHITE}
            icon="search"
            onClick={this.props.onClick}
            size={ButtonSize.SMALL}
          />
        </Tooltip>
      );
    }
    return (
      <Button
        buttonStyle={ButtonStyle.TERTIARY_BLUE}
        icon="search"
        onClick={this.props.onClick}
        size={ButtonSize.SMALL}
        text="Search"
      />
    );
  }
}

export default SearchButton;
